import { render, staticRenderFns } from "./CausaObito.vue?vue&type=template&id=3b697d6f&scoped=true&"
import script from "./CausaObito.vue?vue&type=script&lang=js&"
export * from "./CausaObito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b697d6f",
  null
  
)

export default component.exports